import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const BANNER_BACKGROUND = '#ffff90';

/** Keep in sync with $announcement-banner-height in Parts/Header/Header.module.scss. */
export const ANNOUNCEMENT_BANNER_HEIGHT = 52;

type AnnouncementBannerProps = {
	text: string;
	onClick?: (() => void) | undefined;
	onDismiss?: (() => void) | undefined;
};

const AnnouncementBanner = ({
	text,
	onClick,
	onDismiss,
}: AnnouncementBannerProps) => (
	<div
		className="w-100 text-dark position-relative"
		style={{ background: BANNER_BACKGROUND }}
		role="region"
		aria-label="Announcement"
	>
		<button
			type="button"
			className="w-100 text-dark border-0 d-flex align-items-center justify-content-center"
			style={{
				background: BANNER_BACKGROUND,
				minHeight: ANNOUNCEMENT_BANNER_HEIGHT,
				padding: '14px 4em',
				cursor: onClick ? 'pointer' : 'default',
			}}
			onClick={onClick}
			disabled={!onClick}
			aria-label={onClick ? `Announcement: ${text}` : text}
		>
			<span
				className="text-decoration-underline text-center text-truncate"
				style={{
					color: 'inherit',
					fontSize: 19,
					lineHeight: '23px',
					maxWidth: '100%',
				}}
				title={text}
			>
				{text}
			</span>
		</button>
		<button
			type="button"
			className="position-absolute border-0"
			style={{
				background: BANNER_BACKGROUND,
				color: 'inherit',
				right: 0,
				top: '50%',
				transform: 'translateY(-50%)',
				fontSize: 13,
				lineHeight: 1,
				padding: 4,
				cursor: 'pointer',
				zIndex: 1,
				height: '100%',
				width: '4em',
			}}
			onClick={onDismiss}
			aria-label="Dismiss announcement"
		>
			<FontAwesomeIcon icon={faTimes} />
		</button>
	</div>
);

export default AnnouncementBanner;
